import Swal from "sweetalert2";
export const handleRentalDelete = async (
  rentalId,
  {
    setDeletingRentalId,
    rentals,
    fetchData,
    cars,
    coupons,
    contact,
    drivers,
    tours,
    tourBookings,
    employeeService,
    setCarsData,
    setRentalsData,
    setCouponsData,
    setTransfersData,
    setDriversData,
    setToursData,
    setTourBookingsData,
    setEmployeesData,
    setSeasonalPricing,
    setIsLoading,
    setError,
  }
) => {
  try {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to recover this rental record!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#1e3a8a",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      setDeletingRentalId(rentalId);
      await rentals.delete(rentalId);
      await Swal.fire({
        icon: "success",
        title: "Deleted!",
        text: "The rental record has been deleted.",
        confirmButtonColor: "#1e3a8a",      });
      fetchData();
    }
  } catch (error) {
    console.error("Error deleting rental:", error);
    await Swal.fire({
      icon: "error",
      title: "Error",
      text: "Failed to delete rental. Please try again.",
      confirmButtonColor: "#1e3a8a",
    });
  } finally {
    setDeletingRentalId(null);
  }
};
